import { render, staticRenderFns } from "./MovieHot.vue?vue&type=template&id=0c42521b"
import script from "./MovieHot.vue?vue&type=script&lang=js"
export * from "./MovieHot.vue?vue&type=script&lang=js"
import style0 from "./MovieHot.vue?vue&type=style&index=0&id=0c42521b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports